<template lang="pug">
    div.header
        van-nav-bar.navBar(:title="$t('common.dataStation')", @click-left="goBack", @click-right="closePage" fixed=true, placeholder=true)
            template(#left, v-if="backShowFlag")
                div.backBtn
            template(#right, v-if="closeShowFlag")
                div.closeBtn
</template>

<script>

export default {
    name: 'Header',
    data() {
        return {
            backShowFlag:true,
            closeShowFlag:true
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1)
        },
        closePage() {
            typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.webClose() || (window.vuplex && window.vuplex.postMessage({type: 'close', message: '关闭网页'})) || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.webClose.postMessage(null))
        },
        checkBackShowFlag() {
            if(this.$route.path.split("/").length <= 2) {
                this.backShowFlag = false
            } else{
                this.backShowFlag = true
            }
        },
        checkCloseBtnDisplayByLang() {
            if(CONFIG.env == 'cn'){
                this.closeShowFlag = false
            } else {
                this.closeShowFlag = true
            }
        }
    },
    mounted() {
        this.checkBackShowFlag(),
        this.checkCloseBtnDisplayByLang()
    },
    watch: {
        $route(to, from) {
            this.checkBackShowFlag()
        }
    }
}
</script>

<style lang="scss">
.header {
    .navBar {
        width: 100%;
        height: 60px;
    }
    .van-nav-bar {
        background: url('../assets/navigate_bg.jpg') 100% 100%;
        background-color: transparent;
    }
    .van-nav-bar__title {
        font-size: 22px;
        color: #dceae3;
    }
    .van-nav-bar__content {
        height: 60px;
    }
    .backBtn {
        width: 35.64px;
        height: 38.02px;
        background: url('../assets/back_btn.png') center no-repeat;
        background-size: cover;
    }
    .closeBtn {
        width: 35.64px;
        height: 38.02px;
        background: url('../assets/close_btn.png') center no-repeat;
        background-size: cover;
    }
    .van-hairline--bottom::after{
        border-bottom-width: 0px;
    }
}
</style>